import { Prueba } from './pages/Prueba.js'

/**
 * Fase 1: una sola vista. Cuando existan el login y el dashboard (Fase 4)
 * acá entra el router y la protección de rutas.
 */
export function App() {
  return <Prueba />
}
